import { ApplicationConfig, isDevMode, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { routes } from './app.routes';
import { reducers } from './app.state';
import { STORE_RUNTIME_CHECKS } from '@common/interfaces';
import { tokenInterceptor } from '@shared/token-interceptor';
import { provideToastr } from 'ngx-toastr';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptors([tokenInterceptor])),
    provideAnimations(),
    provideRouter(routes),
    provideStore(reducers, {
      runtimeChecks: {
        ...STORE_RUNTIME_CHECKS,
      },
    }),
    ...(isDevMode() ? [provideStoreDevtools()] : []),
    provideToastr(),
  ],
};
